var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { defaultColor, useGetSize } from '../utils';
const Check = (_a) => {
    var { size: sizeProp, color = defaultColor } = _a, rest = __rest(_a, ["size", "color"]);
    const size = useGetSize(sizeProp);
    return (React.createElement("svg", Object.assign({ width: size, height: size, viewBox: "0 0 24 24", fill: "none" }, rest),
        React.createElement("path", { d: "M19.98 5.99a1 1 0 0 0-.687.303L9 16.586l-3.293-3.293a1 1 0 1 0-1.414 1.415l4 4a1 1 0 0 0 1.414 0l11-11a1 1 0 0 0-.727-1.717", fill: color })));
};
export default Check;
